interface BannerProps {
  src: string;
  alt?: string;
  href?: string;
}

export function Banner({ src, alt = 'Banner', href }: BannerProps) {
  const inner = (
    <div className="w-full aspect-[2/1] sm:aspect-[3/1] md:aspect-[4/1] overflow-hidden bg-champagne">
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover object-top sm:object-center"
      />
    </div>
  );

  if (href) {
    return (
      <a href={href} className="block w-full">
        {inner}
      </a>
    );
  }

  return <div className="w-full">{inner}</div>;
}
